import React, { useEffect, useRef, useState } from "react";

import PersonAddIcon from '@mui/icons-material/PersonAdd';
import PersonRemoveIcon from '@mui/icons-material/PersonRemove';

import InfoIcon from '@mui/icons-material/Info';

import EditIcon from '@mui/icons-material/Edit';
import { Delete } from "@mui/icons-material";

import DialogModifyVehiculo from "./SubComponentsVehiculos/DialogModifyVehiculo";

import { TableRow, TableCell, IconButton, Collapse, Box, Button, DialogActions, DialogContentText, Dialog, DialogTitle, DialogContent, Typography, Tooltip, useTheme } from "@mui/material";
import { VehicleActivityDetail, VehicleClientsDetail } from "./VehicleDetailContent";
import { createVehicleDetailLoader, initialVehicleDetailState } from "../../../utils/vehicleDetailLoader";
import { getPersistentRowHighlightSx } from "../../../utils/rowHighlights";

const API_URL = process.env.REACT_APP_API_URL;

const RowTable = ({data, handleDelete, setOpenAlert, handleUpdateData, areUserAdmin, searchHighlighted}) => {
  const theme = useTheme();
  const [open, setOpen] = useState(false);
  const [openAlertDelete, setOpenAlertDelete] = useState(false);

  const [openInfo, setOpenInfo] = useState(false);
  const [detailState, setDetailState] = useState(initialVehicleDetailState);
  const detailLoaderRef = useRef(null);

  const [openModifyDialog, setOpenModifyDialog] = useState(false);
  
  const handleOpenModifyDialog = () => { setOpenModifyDialog(true) }
  const handleCloseModifyDialog = () => { setOpenModifyDialog(false) }

  useEffect(() => {
    setDetailState(initialVehicleDetailState);
    const loader = createVehicleDetailLoader({
      request: async (vehicleId, { signal }) => {
        const response = await fetch(`${API_URL}/historial/${vehicleId}/detalle/`, { signal });
        if (!response.ok) throw new Error(`Error HTTP ${response.status}`);
        return response.json();
      },
      onStateChange: setDetailState,
    });
    detailLoaderRef.current = loader;
    return () => {
      loader.dispose();
      detailLoaderRef.current = null;
    };
  }, [data.id]);

  const loadDetail = () => detailLoaderRef.current?.load(data.id);

  const handleToggleClients = () => {
    const nextOpen = !open;
    setOpen(nextOpen);
    if (nextOpen) loadDetail();
  };

  const handleToggleInfo = () => {
    const nextOpen = !openInfo;
    setOpenInfo(nextOpen);
    if (nextOpen) loadDetail();
  };

  return (
    <React.Fragment>
      { areUserAdmin && <Dialog
        open={openAlertDelete}
        keepMounted
        onClose={() => {setOpenAlertDelete(false)}}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle>{"Espera un Segundo!"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            Estás apunto de eliminar este Vehiculo del Registro de Vehiculos de este parqueadero
            ¿Estás seguro de que quieras hacer esto?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => {setOpenAlertDelete(false)}} color='error' variant="outlined">No</Button>
          <Button onClick={() => {setOpenAlertDelete(false); handleDelete(data.id); }} color='primary' variant="contained">¡Sí!</Button>
        </DialogActions>
      </Dialog>}

      <TableRow
        aria-label={searchHighlighted ? 'Coincidencia destacada de búsqueda' : undefined}
        data-search-highlight={searchHighlighted ? 'true' : undefined}
        sx={getPersistentRowHighlightSx(theme, false, searchHighlighted)}
      >
        <TableCell component="th" scope="row" sx={{ borderLeft: '2px solid #ddd', borderBottom: '2px solid #ddd'}}> {data.id} </TableCell>
        <TableCell align="left" sx={{ borderLeft: '2px solid #ddd', borderBottom: '2px solid #ddd' }}> {data.placa} </TableCell>
        <TableCell align="left" sx={{ borderLeft: '2px solid #ddd', borderBottom: '2px solid #ddd'}}> {data.tipo_vehiculo} </TableCell>
        <TableCell align="left" sx={{ borderLeft: '2px solid #ddd', borderBottom: '2px solid #ddd'}}> {data.modelo} </TableCell>
        <TableCell align="left" sx={{ borderLeft: '2px solid #ddd', borderBottom: '2px solid #ddd'}}> {data.marca} </TableCell>
        <TableCell align="left" sx={{ borderLeft: '2px solid #ddd', borderBottom: '2px solid #ddd'}}> {data.color} </TableCell>
        <TableCell sx={{ borderLeft: '2px solid #ddd', borderRight: '2px solid #ddd', borderBottom: '2px solid #ddd'}}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <Tooltip title={open ? 'Ocultar clientes asociados' : 'Ver clientes asociados'}>
                <IconButton
                  size="small"
                  onClick={handleToggleClients}
                  aria-label={open ? 'Ocultar clientes asociados' : 'Ver clientes asociados'}
                >
                  {open ? <PersonRemoveIcon /> : <PersonAddIcon />}
                </IconButton>
              </Tooltip>
              {areUserAdmin && (
              <>
                <Tooltip title="Ver actividad del vehículo">
                  <IconButton
                    size="large"
                    onClick={handleToggleInfo}
                    aria-label="Ver actividad del vehículo"
                  >
                    <InfoIcon sx={{ fontSize: '34px' }}/>
                  </IconButton>
                </Tooltip>

                <IconButton
                  size="large"
                  onClick={() => {handleOpenModifyDialog()}}
                >
                  <EditIcon sx={{ fontSize: '33px' }}/>
                </IconButton>

                <IconButton
                  size="large"
                  onClick={() => { setOpenAlertDelete(true) }}
                >
                  <Delete sx={{ fontSize: '33px' }}/>
                </IconButton>
              </>
              )}

          </Box>
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={7}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box sx={{ margin: 1 }}>
              <Typography sx={{ fontWeight: 'bold', mb: 1 }}>Clientes registrados de este vehículo</Typography>
              <VehicleClientsDetail detailState={detailState} />
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>

      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={7}>
          <Collapse in={openInfo} timeout="auto" unmountOnExit>
            <Box sx={{ margin: 2 }}>
              <VehicleActivityDetail detailState={detailState} />
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>

      { areUserAdmin && <DialogModifyVehiculo openDialog={openModifyDialog} handleCloseDialog={handleCloseModifyDialog} setOpenAlert={setOpenAlert} data={data} handleUpdateData={handleUpdateData}/> }

    </React.Fragment>
  );
}

export default RowTable;
